
export const network = {
  baseUrl: process.env.REACT_APP_API_BASE_URL,
  api_route: 'api',
  auth_route: 'OAuth',
  timeout: 30000,
  signalRTimeout: 60000, // timeout مخصوص SignalR
  heartbeatInterval: 30000, // interval برای heartbeat
};

// Tag printed on the splash screen. Inlined at build time from web/.env.ci
// (written by deploy/Dockerfile from the RELEASE_TAG build arg), with
// web/.env.production as the local default.
export const releaseTag = process.env.REACT_APP_RELEASE_TAG;

export const market = 'googleplay'; //Market: "googleplay" | "cafebazaar" | "myket" | "site" | "pwa" | "develop"
